import Vue from 'vue'
import AscNestedCell from '@/components/atoms/AscNestedCell'

export default Vue.extend({
  components: {
    AscNestedCell,
  },

  data: function () {
    return {}
  },

  methods: {
    handleArrowClicked() {
      this.params.handleArrowClicked(this.params)
    },
  },

  template: `<asc-nested-cell 
  :params="params" 
  :handle-arrow-clicked="handleArrowClicked" />`,
})
